<template name="u-select">
  <div>
    <van-field v-bind="$attrs" @click="show = true" :value="name" />

    <van-popup v-model="show" position="bottom" class="u-popup">
      	<div class="title">{{popupTitle}}</div>
          <div style="padding: 10px;">
              <van-search   @input="inputFilter" placeholder="请输入小区名称"
                v-model="keyword"></van-search>
            <div  class="scroll-Y" >
              <div v-for="(item,index) in arr" :key="index" class="xq-item" @click="clickItem(item)">
                {{item.text}}
              </div>
            
            
            </div>
    	</div>

      <!-- <van-picker show-toolbar :columns="dataList" @confirm="onConfirm" @cancel="show = false" value-key="text" /> -->
    </van-popup>
  </div>
</template>

<script>
/**
 * input 选择框
 * 不要直接引用父组件传过来的值，可以把接收到的父组件的值赋值给一个新的参数
 * 1.加入页面传入url,和请求参数。
 * 2.看是否加入选择后得回调。
 * @description
 */
import { getAction } from '@/api/manage'
export default {
  name: 'u-select',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择2',
    },
    list: {
      type: Array,
      default() {
        return []
      },
    },
    ifNetData: {
      type: Boolean,
      default: true,
    },
    defValue: {
      type: String,
      default: '',
    },
    xqlb:{
      type: String,
      default: "1",
    },
    id:{
      type: String,
      default: "",
    },
    dictCode: String,
    popupTitle: {
        type: String,
        default: "请选择小区"
      },
  },
  created() {
      this.getData()
  },
  data() {
    return {
      show: false,
      dataList: this.list,
      name: '',
      myValue: this.value,
      keyword:'',
      arr:[],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.dataList = this.list
      },
    },
    defValue: {
      immediate: true,
      handler() {
        this.name = this.defValue
      },
    },
    myValue(newVal) {
      console.log("newVals",newVal);
      this.$emit('input', newVal)
    },
  },
  methods: {
    /**
     * 公司获取字典值得url
     */
    getData() {
      let url = `/zhshj/hmfwbsbx/${this.dictCode}`
      let params = {}
      getAction(url,params).then((res) => {
        if (res.success) {
          let list = res.result
            this.dataList = list;
            this.arr = [...list];
         }
      })
    },
      inputFilter(e){
        this.arr = this.dataList.filter(m => {
        	return m.text.includes(this.keyword)
        })
        
      },
      clickItem(e){
        this.name = e.text
        this.$emit('input', e.value)
        this.show =false;
      }
  },
}
</script>

<style lang="less" scoped>


 .u-popup {
		.title {
			border-bottom: 1px solid #f7f7f7;
			padding: 10px;
			text-align: center;
			font-weight: bold;
		}
	}
  
.scroll-Y {
		height: 320px;
    overflow-y: scroll;
	}
  
  .xq-item{
    padding: 8px 0;
    
    &:active {
      background-color: #eeeeee;
    }
   &:not(:last-child){
     border-bottom: 0.5px solid #DDDDDD;
   }
  }
</style>
